import React from 'react';
import { Lock, XCircle } from 'lucide-react';
export function EnemySection() {
  return <section className="w-full bg-navy py-20 px-4 relative overflow-hidden" data-id="element-39">
      {/* Background accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-danger/5 blur-[120px] rounded-full pointer-events-none" data-id="element-40" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <div className="inline-flex items-center justify-center p-3 bg-danger/10 rounded-full mb-4" data-id="element-43">
            <Lock className="w-8 h-8 text-danger" data-id="element-44" />
          </div>
          <h2 className="text-3xl md:text-4xl font-headline font-bold text-white uppercase mb-4" data-id="element-45">
            Section 2: The Enemy{' '}
            <span className="text-danger" data-id="element-46">(The Pay-to-Play System)</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-47">
          <div className="space-y-6 text-gray-300 text-lg" data-id="element-48">
            <p data-id="element-49">
              Most Hispanic parents make the same mistake:{' '}
              <span className="text-white font-semibold" data-id="element-50">
                Believing that if their kid scores a lot of goals, a scout will
                "magically appear" at the public park on Sunday.
              </span>
            </p>

            <div className="flex items-center gap-3 text-danger font-bold text-2xl" data-id="element-51">
              <XCircle className="w-8 h-8" data-id="element-52" />
              <span data-id="element-53">That's not going to happen.</span>
            </div>

            <p data-id="element-54">
              Elite academies and Premier clubs (ECNL, MLS Next) operate like a
              private club. They aren't looking for the best player; they are
              looking for the player who already understands the{' '}
              <span className="text-gold" data-id="element-55">"language of the system"</span>.
            </p>
          </div>

          <div className="bg-navy-light border border-white/10 p-8 rounded-xl shadow-2xl relative" data-id="element-56">
            <div className="absolute -top-3 -right-3 bg-danger text-white text-xs font-bold px-3 py-1 rounded uppercase tracking-wider" data-id="element-57">
              The Reality
            </div>
            <h3 className="text-xl font-headline font-bold text-white mb-4" data-id="element-58">
              What the Scout actually looks at:
            </h3>
            <p className="text-gray-400 mb-6" data-id="element-59">
              While you focus on your kid doing "YouTube tricks," the scout is
              evaluating 5 metrics that have nothing to do with the ball... and
              that no one has told you about.
            </p>
            <div className="space-y-3" data-id="element-60">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="h-2 bg-navy rounded-full overflow-hidden" data-id="element-61">
                  <div className="h-full bg-gradient-to-r from-danger to-orange-500 w-3/4 opacity-50" data-id="element-62" />
                </div>)}
            </div>
            <p className="text-center text-xs text-muted mt-4 uppercase tracking-widest" data-id="element-63">
              Hidden data from parents
            </p>
          </div>
        </div>
      </div>
    </section>;
}